import {
  faChevronDown,
  faInfoCircle,
  faLeaf,
} from '@fortawesome/pro-solid-svg-icons'

import CalculatorImage from 'Assets/images/layout/calculator.svg'

import { Alert } from '../Alert/Alert'
import { Heading } from '../Heading/Heading'
import { PrimaryButton } from '../PrimaryButton/PrimaryButton'
import { TertiaryButton } from '../TertiaryButton/TertiaryButton'
import { Widget } from './Widget'

export const WidgetPresentation = () => (
  <div>
    <Heading className="pt-4" size={4}>
      Widget:
    </Heading>

    <div className="pt-4">
      {/* *** Widget *** */}

      <Widget
        className="mb-4 mb-l-6 card-widget"
        content={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.Ut enim ad
            minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
        }
        imageSrc={CalculatorImage}
        primaryIcon={faLeaf}
        title="Simple widget"
      >
        <PrimaryButton appearance="outline">Start</PrimaryButton>
      </Widget>

      {/* *** Widget with alert  and button *** */}

      <Widget
        className="mb-4 mb-l-6 card-widget"
        content={
          <>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>

            <Alert iconLeft={faInfoCircle} variant="success">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor.
              </p>
            </Alert>
          </>
        }
        imageSrc={CalculatorImage}
        primaryIcon={faLeaf}
        rightContent={<TertiaryButton asIcon={faChevronDown} />}
        title="Simple widget"
      >
        <PrimaryButton appearance="outline">Click here</PrimaryButton>
      </Widget>
    </div>
  </div>
)
